export const handbookCopy = {
  handb_prev: "Poprzednia",
  handb_next: "Następna",
  handb_on_this_page: "Na tej stronie",
  handb_like_dislike_title: "Czy ta strona jest przydatna?",
  handb_like_desc: "Tak",
  handb_dislike_desc: "Nie",
  handb_thanks: "Dziękujemy za feedback",
}
